import logoAnimated from 'Assets/Icons/logo-animated.svg';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { Helmet } from 'react-helmet-async';
import styles from './UnauthorizedScopePage.module.sass';

export const UnauthorizedScopePage = () => {
    return <PageTemplate>
        <Helmet>
            <title>Geen toegang - Growing People</title>
        </Helmet>

        <div className={styles.container}>
            <img src={logoAnimated} width="300px" />

            <div className={styles.message_container}>
                <div className={styles.message}>Je hebt geen toegang tot dit deel in het systeem.</div>
                <div className={styles.submessage}>Vraag aan de Systeem Beheerder om toegang en probeer later nog een keer. CODE: SCOPE</div>
            </div>
        </div>
    </PageTemplate>;
}